const Form070SC = {
    stepName: {
        Statement: "重要事项",
        schoolInfo: "学校资料",
        SectionA: "甲部",
        SectionB: "乙部",
        certification: "丙部\n认证",
        Confirmation: "确认",
    },
    label: {
        reasonOption: {
            a: "有薪病假／产假／肺病特别假期",
            b: "有薪进修假期",
            c: "有薪进修假期（学校如有一位或多于一位教师修读指定的专业进修课程而为期达30个连续曆日或以上），请注明课程编号；",
            d: "给予教师有薪假期，以便出任陪审员或证人",
            e: "有薪侍产假",
            f: "其他有薪假期",
            x: "无薪病假／产假／肺病特别假期",
            y: "其他无薪假期",
        },
        surplusOption: {
            yes: "有",
            no: "沒有",
        },
        formTypeOption: {
            N: "新表格",
            R: "修订表格",
        },
        changePreClaimOption: {
            unDelete: "不更改先前声明",
            delete: "删除先前声明",
            change: "更改先前声明",
        },
        partBi: "乙部 有关以月薪聘任的臨时教师，请递交教育局网页内的聘任表格（",
        partBii: "http://www.edb.gov.hk",
        partBiii: "→ 学校行政及管理 → 一般行政 → 有关学校教职员 → 聘任事宜）",
        partC: "丙部 认证",
        // note: "重要事项",
        statement: "个人资料收集声明",
        surplusTeachers: "过剩教师：",
        surplusNo: "过剩教师数量",
        termsConditions: "本人已阅读｢个人资料收集声明｣及完全明白其内容。",
        iamStatement: "本人明白需透过｢智方便+｣账户以办理申请。",
        headerOne: "学校资料",
        schoolName: "学校名称",
        schoolCode: "学校代码",
        Month: "月份",
        Year: "年份",
        headerTwoA:
            "甲部 发还因教师休假30至89曆日或教师连续放取3天或以上的侍产假",
        headerTwoB:
            "或于调整班级数目后不获发放整合代课教师津贴中的全年经常性现金津贴的学校，其休假连续3日或以上的教师数目超逾过剩教师数目",
        headerTwoC:
            "而聘任合资格代课教师所支付的薪金及强积金计划雇主供款（有关必须向强积金供款的代课教师，如申領津贴期少于60天，请提供强积金供款的资料证明）",
        headerTwoNote1:
            "以薪金津贴聘请的教师如放取连续3天或以上的侍产假，学校便可以实报实销形式申请发还支付代课教师的开支。有关详情，请参阅教育局通告第16/2015号。",
        headerTwoNote2: "有关详情请参阅本指引的附件IV。",
        formType: "新/修订表格",
        changePreclaim: "不更改先前声明／删除先前声明／更改先前声明",
        preclaimNum: "请注明前次申领的申请编号",
        previousDate: "前次申领表格日期：",
        previousFormFile: "前次申领表格副本：",
        applicationNum: "申请编号",

        headerThree: "休假教师",
        leaveTeacherName: "姓名",
        leaveTeacherSRN: "职员参考编号",
        leaveTeacherReason: "缺勤原因",
        leaveTeacherPost: "职位",
        leaveDatelabel: "休假日期",
        leaveStartTime: "由",
        leaveEndTime: "至",
        supplyTeacherName: "代课教师姓名",
        supplyDatelabel: "代课日期",
        supplyStartTime: "由",
        supplyEndTime: "至",
        workDaysNo: "工作日数",
        DailyRate: "日薪率",
        salaryAmount: "薪金",
        trusteeReceipt:
            "已付予代课教师及/或强积金计划的受託人有关薪酬的收据证明：",
        MPFSubsidy: "强积金供款津贴",
        contractDatelabel: "合约期",
        contractStartTime: "由",
        contractEndTime: "至",
        MPFfile: "强积金供款的资料证明：",
        totalSalaryAmount: "总额（薪金总额）",
        totalMPFSubsidy: "总额（强积金供款津贴）",
        specify: "（请说明原因）",
        otherReason: "其他有薪假期的原因",
        validReason: "原因",
        courseId: "有薪进修假期的课程编号",
        confirm: "确认",
        tooltip1:
            "以薪金津贴聘请的教师如放取连续3天或以上的侍产假，学校便可以实报实销形式申请发还支付代课教师的开支。有关详情，请参阅教育局通告第16/2015号。",
        tooltip2:
            "学校必须按照教育局通告第1／2006号以及第16／2015号(侍产假适用)的规定批假。",
        partCLabel: "本校會把多付的津貼退還政府。",

        signDate: "日期",
        signContactPerson: "联络人",
        signTelNo: "电话号码",
        signSsdo: "高级学校发展主任",
    },
    noteList: {
        noteOne: "请填写休假教师的职员参考编号。",
        noteTwo: "请以下列字母标明缺勤原因─",
        noteTwoB:
            "学校必须按照教育局通告第1／2006号以及第16／2015号（侍产假适用）的规定批假。",
        noteThree:
            "请注意，学校申请发还的津贴，是用以聘请合资格的日薪代课教师，以代替放取核准假期的教学人员。如有关教学人员在休假期间的教学和其他职务是由校内其他人员代为处理，学校不能就此代课安排申请发还津贴。",
        noteFour:
            "工作日數不应包括星期日、星期六（短周）、公众假期、由学校自行订定的假期或教师毋须执行职务的任何周日。",
        noteFive:
            "有关资助学校代课教师当时适用的日薪率，请参阅相关的教育局通函。",
        noteSix:
            "如代课期少于60个历日，但代课教师须向强积金供款，请提供证明资料。",
        noteSeven:
            "有关以月薪聘任的臨时教师，请递交教育局网页内的聘任表格（http://www.edb.gov.hk → 学校行政及管理 → 一般行政 → 有关学校教职员 → 聘任事宜）",
    },
    statementList: [
        {
            text: "本人证实*–",
        },
        {
            text: "有关薪酬已付予代课教师及／或强积金计划的受託人。随函付上有关收据，以供记錄存档；",
        },
        {
            text: "上述申请不在整合代课教师津贴的涵盖范围；",
        },
        {
            text: "本申请符合有关整合代课教师津贴申请所订明的条件；",
        },
        {
            text: {
                t1: "本校",
                t2: "过剩教师",
                t3: "，而在聘请任何代课教师前，过剩教师数目已经抵销；",
                t4: "并",
                t5: "名",
            },
        },
        {
            text: "本校没有就上述假期／空缺向政府提出其他津贴的申请，例如以现金津贴取代额外英语教师职位及把小数位教师职位转为小数位职位现金津贴；",
        },
        {
            text: "如上述编制内的教师放取侍产假，学校已按照相关规定批准；以及",
        },
        {
            text: "学校已查核代课教师的教师注册文件，以及征得他们的同意，向教育局申请发放其教师注册资料。",
        },
    ],

    statemenStep: [
        {
            step: "（i）",
        },
        {
            step: "（ii）",
        },
        {
            step: "（iii）",
        },
        {
            step: "（iv）",
        },
        {
            step: "（v）",
        },
        {
            step: "（vi）",
        },
        {
            step: "（vii）",
        },
    ],

    errorMsg: {
        afterThisSupplyDate: "请输入代课开始之后的日期",
        numLimit: "请输入{{limit}}",
        dayslimit1:
            "学校可以实报实销形式申请发还因教师休假30至89历日而聘任代课教师所支付的薪金，以下情况除外﹕",
        dayslimit2: "教师连续放取3天或以上的侍产假；及／或",
        dayslimit3:
            "于调整班级数目后不获发放整合代课教师津贴中的全年经常性现金津贴的学校，其休假连续3日或以上的教师数目超逾过剩教师数目。",
        // leaveDate: "截止日期不得晚于该科目学年的8月31日",
        supplyDate: "代课开始日期应该在休假期间范围内",
        supplyDateEnd: "代课结束日期应该在休假期间范围内",
        contractDate: "截止日期不得晚于该科目学年的8月31日",
        date: {
            year: "请输入有效年份",
        },
        number: {
            min: "此项最小值必须大于0",
        },
        paternityLeave: "带薪陪产假，休假期限>=3个日历日",
        workDays: "工作日数不能大于代课天数",
        E0001: "请输入一个有效的联络人",
    },
};
export default Form070SC;
